var app = angular.module("leonardo");

var LevelListFilter = function(
  $scope,
  $controller
) {

  $controller('FiltersBaseController', {$scope: $scope});

  $scope.filters_options = [
    {
      id: 'name',
      name: 'Name',
      label: null,
      inline: false,
      type: 'text',
      placeholder: 'Search name',
      condition: true,
      conflicts: [],
      onSubmit: $scope.filter
    }
  ];

};

app.controller('LevelListFilter', [
  '$scope',
  '$controller',
  LevelListFilter
]);
